import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '40px 20px', maxWidth: '800px', margin: '0 auto', color: '#333', lineHeight: '1.6' }}>
      <h1>Политика конфиденциальности</h1>
      <p>Последнее обновление: 15 июля 2026 г.</p>
      <p>Проект <strong>REALWORK</strong> заботится о безопасности ваших данных. Настоящая Политика объясняет, какие данные мы собираем и как их защищаем.</p>
      
      <h3>1. Сбор информации</h3>
      <p>Мы можем собирать следующие данные: технические данные (IP-адрес, тип браузера), адрес электронной почты (при обращении в поддержку) и публичные данные вашего профиля при авторизации через сторонние сервисы.</p>
      
      <h3>2. Использование данных</h3>
      <p>Все собранные данные используются исключительно для обеспечения работоспособности платформы REALWORK, улучшения качества сервиса и оперативной связи службы поддержки с пользователем.</p>
      
      <h3>3. Безопасность</h3>
      <p>Мы применяем современные методы шифрования и защиты информации для предотвращения несанкционированного доступа к вашим персональным данным. Мы никогда не передаем ваши данные третьим лицам.</p>
    </div>
  );
};

export default PrivacyPolicy;